import React from "react";
import PropTypes from "prop-types";

import { Colours } from "@learningblocks/shared-components";

export default function Button(props) {
  const style = {
    color: "white",
    padding: "8px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
    margin: "8px 0",
  };

  switch (props.type) {
    case "Primary":
      style.background = Colours.yellow1;
      style.color = Colours.charcoal1;
      style.fontSize = "16px";
      style.padding = "19px 61px";
      break;
    case "Secondary":
      style.background = Colours.white;
      style.color = Colours.navy1;
      style.border = "1px solid " + Colours.navy1;
      style.fontSize = "16px";
      style.padding = "8px";
      break;
    case "Tertiary":
      style.background = Colours.navy1;
      break;
    case "Card-primary":
      style.background = Colours.blue1;
      style.width = "100%";
      style.marginBottom = 0;
      break;
    case "Card-secondary":
      style.background = Colours.yellow1;
      style.width = "100%";
      style.color = Colours.charcoal1;
      style.marginBottom = 0;
      break;
    case "Close":
      style.color = Colours.navy1;
      style.background = "transparent";
      style.display = "flex";
      style.alignContent = "baseline";
      style.margin = 0;

      break;
  }

  return (
    <button class={props.type} onClick={props.onClick} style={style}>
      {props.children}
    </button>
  );
}
Button.PropTypes = {
  onClick: PropTypes.function,
  type: PropTypes.string,
  children: PropTypes.object,
};
